import React, { useContext, useEffect, useState } from "react";
import { API } from "../../shared/Api/Api";
import { Context } from "../../shared/Context/Context";
import InfoAdmin from "./InfoAdmin/InfoAdmin";
import InfoUser from "./InfoUser/InfoUser";

const Info = () => {
  const [info, setInfo] = useState();
  const [reload, setReload] = useState(false);
  const { tabletOrLess, isAdmin } = useContext(Context);

  useEffect(() => {
    llamada();
  }, [reload]);

  const llamada = () => {
    API.get("info").then((res) => {
      setInfo(res.data);
    });
  };

  return (
    <>
      {isAdmin ? (
        <InfoAdmin
          reload={reload}
          setReload={setReload}
          tabletOrLess={tabletOrLess}
          info={info}
          llamada={llamada}
        ></InfoAdmin>
      ) : (
        <InfoUser tabletOrLess={tabletOrLess} info={info}></InfoUser>
      )}
    </>
  );
};

export default Info;
